import { Type } from 'class-transformer';
import { IsDate, IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';
import { UserId } from '../../types';
import { UserAdminCredentialsDto, UserCredentialsDto } from './user-credentials.dto';
import { IdentityConciliationStatus, IdentityVerificationStatus } from './user-identity.dto';

export class StripeVerificationSessionDto {
  @IsString()
  @IsNotEmpty()
  id!: string;

  @IsEnum(IdentityVerificationStatus)
  @IsNotEmpty()
  status!: IdentityVerificationStatus;

  @IsDate()
  @Type(() => Date)
  @IsNotEmpty()
  createdAt!: Date;

  @IsOptional()
  verifiedBy?: UserId;

  @IsDate()
  @Type(() => Date)
  @IsOptional()
  verifiedAt?: Date;

  @IsString()
  @IsOptional()
  verifiedSource?: string;

  @IsEnum(IdentityConciliationStatus)
  @IsOptional()
  conciliation?: IdentityConciliationStatus;

  @IsNumber()
  @IsOptional()
  matchScore?: number;
}

export class StripeIdentityVerificationUserIdentityDto {
  @IsString()
  @IsNotEmpty()
  firstName!: string;

  @IsString()
  @IsNotEmpty()
  lastName!: string;
}

export class IdentityVerificationUserIdentityDto {
  @IsString()
  @IsNotEmpty()
  firstName!: string;

  @IsString()
  @IsNotEmpty()
  lastName!: string;

  @IsEnum(IdentityVerificationStatus)
  @IsNotEmpty()
  verificationStatus!: IdentityVerificationStatus;
}

export class IdentityVerificationStatusDto {
  @ValidateNested()
  @Type(() => StripeVerificationSessionDto)
  @IsNotEmpty()
  session!: StripeVerificationSessionDto;

  @ValidateNested()
  @Type(() => StripeIdentityVerificationUserIdentityDto)
  @IsOptional()
  stripeIdentity?: StripeIdentityVerificationUserIdentityDto;

  @ValidateNested()
  @Type(() => IdentityVerificationUserIdentityDto)
  @IsOptional()
  userIdentity?: IdentityVerificationUserIdentityDto;
}

export class StripeVerificationDto {
  @IsEnum(IdentityVerificationStatus)
  @IsNotEmpty()
  status!: IdentityVerificationStatus;

  @ValidateNested({ each: true })
  @Type(() => StripeVerificationSessionDto)
  @IsOptional()
  sessions?: StripeVerificationSessionDto[];
}

export class StripeMetadataDto {
  @IsString()
  @IsOptional()
  customerId?: string;

  @ValidateNested()
  @Type(() => StripeVerificationDto)
  @IsOptional()
  verification?: StripeVerificationDto;
}

export class UserMetadataDto {
  @IsDate()
  @IsOptional()
  lastLoginAt?: Date;

  @ValidateNested()
  @Type(() => UserCredentialsDto)
  @IsOptional()
  credentials?: UserCredentialsDto;

  @ValidateNested()
  @Type(() => StripeMetadataDto)
  @IsOptional()
  stripe?: StripeMetadataDto;
}

export class UserAdminMetadataDto extends UserMetadataDto {
  @ValidateNested()
  @Type(() => UserAdminCredentialsDto)
  @IsNotEmpty()
  declare credentials: UserAdminCredentialsDto;
}
